import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DashBoardDataInterface } from '../../models/dashboard/dashboard/dashboard-data';

interface IInitialState {
  dashboardStatsData?: DashBoardDataInterface;
}

const initialState: IInitialState = {
  dashboardStatsData: undefined
};

const dashboardDataSlice = createSlice({
  name: 'dashboardDataSlice',
  initialState,
  reducers: {
    setDashboardData(state, action: PayloadAction<DashBoardDataInterface>) {
      state.dashboardStatsData = action.payload;
    },
  },
});

export const dashboardDataActions = dashboardDataSlice.actions;
export default dashboardDataSlice.reducer;
